import { Inject, Injectable } from "@angular/core";
import { BaseService } from "./base-service";
import { HttpClient, HttpParams } from "@angular/common/http";
import { APP_CONFIG } from "../lib/angular/injection-tokens";
import { IAppConfig } from "../lib/config/app-config";
import { Observable } from "rxjs";
import { AppConstants } from "../constants/constants";
import { LearnerResourcesDto, UpdateLearnerResourcesDto } from "../_models/LearnerResources";

@Injectable({
  providedIn: "root",
})
export class LearnerResourcesService extends BaseService {
  private baseUrl: string = this.config.protectedResourceEndpoint;
  private static readonly path: string = "LearnerResources/";
  private static readonly GET_MODULE_TYPES_OF_RESOURCES: string = "getmoduletypesofresources";
  private static readonly GET_LEARNER_RESOURCES: string = "getlearnerresources";
  private static readonly UPDATE_LEARNER_RESOURCES: string = "updatelearnerresources";

  constructor(
    http: HttpClient,
    @Inject(APP_CONFIG) private config: IAppConfig
  ) {
    super(http);
  }

  public getModuleTypesOfResources$(courseId: number) : Observable<string[]> {
    let params = new HttpParams();
    
    params = params.append(AppConstants.COURSE_ID, String(courseId));

    return this.http.get<string[]>(
      this.baseUrl +
      LearnerResourcesService.path +
      LearnerResourcesService.GET_MODULE_TYPES_OF_RESOURCES,
      { params }
    );
  }

  public getLearnerResources$(
    courseId: number,
    langCode: string,
    isInitialLoad: boolean
  ) : Observable<LearnerResourcesDto[]> {
    let params = new HttpParams();
    
    params = params.append(AppConstants.COURSE_ID, String(courseId));
    params = params.append(AppConstants.LANG_CODE, String(langCode));
    params = params.append(AppConstants.IS_INITIAL_LOAD, String(isInitialLoad));

    return this.http.get<LearnerResourcesDto[]>(
      this.baseUrl +
      LearnerResourcesService.path +
      LearnerResourcesService.GET_LEARNER_RESOURCES,
      { params }
    );
  }

  public updateLearnerResources$(
    updateFilter: UpdateLearnerResourcesDto
  ) : Observable<boolean> {
    return this.http.put<boolean>(
      this.baseUrl + 
      LearnerResourcesService.path +
      LearnerResourcesService.UPDATE_LEARNER_RESOURCES,
      updateFilter
    );
  }
}